import React, { memo } from "react";
import { Grid } from "@mui/material";

function LoginLayoutSplit({
  direction,
  justifyContent,
  showHero,
  hero,
  content,
}) {
  return (
    <Grid
      container
      rowSpacing={0}
      gridTemplateColumns="repeat(12, 1fr)"
      height="100%"
      columnSpacing={{ xs: 0, md: 4 }}
      direction={direction}
      justifyContent={justifyContent}
    >
      {showHero && (
        <Grid className="hero-logo" item xs={12} md={6}>
          {hero}
        </Grid>
      )}
      {content}
    </Grid>
  );
}

export default memo(LoginLayoutSplit);
